import { useEffect, useMemo } from 'react';
import { useCalendarContext } from '../calendar/CalendarContextProvider';
import { EIGHT_AM_IN_MINUTES } from '../constants/scrollToTime';
import { getAmountToScroll } from '../lib/scrollToTime';
import { useTheme } from '../lib/styles';
export default function useScrollToTime({
  scrollingElementRef,
  time = EIGHT_AM_IN_MINUTES,
  scrollOnViewChange = false
}) {
  const {
    uiAddonCalendars: {
      util: {
        raw
      },
      dayView: {
        hourHeight
      }
    }
  } = useTheme();
  const rawHourHeight = raw(hourHeight);
  const {
    hasScrolledToTime,
    setHasScrolledToTime
  } = useCalendarContext();
  const amountToScroll = useMemo(() => getAmountToScroll(time, rawHourHeight), [time, rawHourHeight]);
  useEffect(() => {
    if (!hasScrolledToTime && scrollingElementRef.current && 'scrollTop' in scrollingElementRef.current) {
      scrollingElementRef.current.scrollTop = amountToScroll;
      setHasScrolledToTime(true);
    }
  }, [amountToScroll, hasScrolledToTime, setHasScrolledToTime, scrollingElementRef]);
  useEffect(() => {
    if (scrollOnViewChange && scrollingElementRef.current) {
      scrollingElementRef.current.scrollTop = amountToScroll;
    }
    /**
     * We only want this to update when the view changes, not when amountToScroll changes.
     * Otherwise, the scroll will occur when the minute changes.
     * This hook is called every time the view changes, so this only needs to run once with no deps.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return scrollingElementRef;
}